import React from 'react';
import { Popconfirm, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const ConfirmDelete = ({ itemName, onConfirm, loading, children }) => {
  return (
    <Popconfirm
      title={`Delete ${itemName}?`}
      description="This action cannot be undone."
      icon={<ExclamationCircleOutlined style={{ color: 'red' }} />}
      onConfirm={onConfirm}
      okText="Delete"
      cancelText="Cancel"
      okButtonProps={{ danger: true, loading: loading }}
    >
      {children || <Button danger type="text">Delete</Button>}
    </Popconfirm>
  );
};

export default ConfirmDelete;